import dynamic from 'next/dynamic'

export const DynamicChooseStoreModal = dynamic(
  () => import('.').then((mod) => mod.ChooseStoreModal),
  { ssr: false },
)
